import {APIClient} from '../utils/APIClient';
import {API_URL} from '../settings/local_settings';

// Capa API de la página «Aprende Dashbo» (`/aprende`) y de su lanzador en el riel (contrato §2 de la
// tanda 2026-10-03-aprende-dashbo). La pantalla de Usuarios tiene la suya (`learnTeamApi.js`).
//
// Las rutas cuelgan de `learning/`, nunca de `agency/team/…`: `^agency/team` está declarado sin `$`
// en el backend y se come cualquier ruta que empiece igual. Todas responden con `OKResponse`, y las
// escrituras devuelven el MISMO `data` que `GET learning/me/`: la pantalla repinta sin otro pedido.

// Sin `API_URL`: `APIClient.clearCache` borra por substring (ver `utils/onboardingProgress.js`).
export const LEARNING_ME_PATH = 'learning/me/';

const taskPath = (key, action) => `${API_URL}learning/tasks/${encodeURIComponent(key)}/${action}/`;

export const LearnApi = {
    /**
     * Con `cache: true` comparte el pedido con los demás que lo piden en el mismo tick (la entrada del
     * menú, el lanzador y la pantalla de Usuarios) y sirve la copia de 30 s al navegar.
     */
    getMe({cache = true} = {}) {
        return new APIClient(`${API_URL}${LEARNING_ME_PATH}`).call('GET', {}, {cache});
    },

    skip(key) {
        return new APIClient(taskPath(key, 'skip')).call('POST', {});
    },

    unskip(key) {
        return new APIClient(taskPath(key, 'unskip')).call('POST', {});
    },

    /** «Marcar como hecho»: sólo en las tareas con `can_mark` (el backend rechaza el resto). */
    complete(key) {
        return new APIClient(taskPath(key, 'complete')).call('POST', {});
    },

    /** Deshace SÓLO un tilde a mano (`source: manual`). */
    uncomplete(key) {
        return new APIClient(taskPath(key, 'uncomplete')).call('POST', {});
    },

    saveProfile(roles) {
        return new APIClient(`${API_URL}learning/profile/`).call('POST', {roles});
    },

    markNudgeSeen() {
        return new APIClient(`${API_URL}learning/nudge/seen/`).call('POST', {});
    },
};

/** Olvidar la copia cacheada: después de una escritura, el próximo GET con cache no puede ser viejo. */
export function forgetLearningMe() {
    APIClient.clearCache(LEARNING_ME_PATH);
}
